import Vue from 'vue';
import VueRouter from 'vue-router';

// import PlaceHolder from '@/views/PlaceHolder.vue';

import Login from '@/views/Login.vue';

import SalesRoot from '@/views/SalesRoot.vue';
import SalesHome from '../views/sales/Home.vue';
import SalesNewOrder from '../views/sales/NewOrder.vue';
import SalesHistory from '../views/sales/History.vue';
import Settings from '../views/sales/Settings.vue';
import SalesProfilePerformance from '../views/sales/ProfilePerformance.vue';

import CSRoot from '@/views/CSRoot.vue';
import CSHome from '../views/cs/CSHome.vue';
import CSSellRecords from '../views/cs/CSSellRecords.vue';
import CSCustomerHistory from '../views/cs/CSCustomerHistory.vue';
import CSPrint from '../views/cs/CSPrint.vue';
// import CSNewOrder from '../views/cs/CSNewOrder.vue';

import AdminRoot from '@/views/AdminRoot.vue';
import AdminHome from '../views/admin/AdminHome.vue';
import AdminPendingApproval from '../views/admin/AdminPendingApproval.vue';
import AdminPriceSettings from '../views/admin/AdminPriceSettings.vue';
import AdminSellerRecords from '../views/admin/AdminSellerRecords.vue';
import AdminPermissionSettings from '../views/admin/AdminPermissionSettings.vue';

import ApproverRoot from '../views/ApproverRoot.vue';
import ApproverHome from '../views/approver/ApproverHome.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '',
    redirect: 'sales', // redirects to sales (FOR NOW..)
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/sales',
    // name: 'sales',
    component: SalesRoot,
    children: [
      {
        path: '/',
        name: 'sales.home',
        component: SalesHome,
      },
      {
        path: '/sales/new-order',
        name: 'sales.new-order',
        component: SalesNewOrder,
      },
      {
        path: '/sales/history',
        name: 'sales.history',
        component: SalesHistory,
      },
      {
        path: '/sales/settings',
        name: 'sales.settings',
        component: Settings,
      },
      {
        path: '/sales/profile-performance',
        name: 'sales.profile-performance',
        component: SalesProfilePerformance,
      },
    ],
  },
  {
    path: '/cs',
    // name: 'cs',
    component: CSRoot,
    children: [
      {
        path: '/',
        name: 'cs.home',
        component: CSHome,
      },
      {
        path: '/cs/new-order',
        name: 'cs.new-order',
        component: SalesNewOrder,
        props: {
          root: true,
        },
      },
      {
        path: '/cs/sell-record',
        name: 'cs.sell-record',
        component: CSSellRecords,
      },
      {
        path: '/cs/customer-history',
        name: 'cs.customer-history',
        component: CSCustomerHistory,
      },
      {
        path: '/cs/settings',
        name: 'cs.settings',
        component: Settings,
      },
      {
        path: '/cs/print',
        name: 'cs.print',
        component: CSPrint,
      },
    ],
  },
  {
    path: '/admin',
    // name: 'admin',
    component: AdminRoot,
    children: [
      {
        path: '/',
        name: 'admin.home',
        component: AdminHome,
      },
      {
        path: '/admin/pending-approval',
        name: 'admin.pending-approval',
        component: AdminPendingApproval,
      },
      {
        path: '/admin/price-settings',
        name: 'admin.price-settings',
        component: AdminPriceSettings,
      },
      {
        path: '/admin/seller-records',
        name: 'admin.seller-records',
        component: AdminSellerRecords,
      },
      {
        path: '/admin/permission-settings',
        name: 'admin.permission-settings',
        component: AdminPermissionSettings,
      },
      {
        path: '/admin/print',
        name: 'admin.print',
        component: CSPrint,
      },
      {
        path: '/admin/settings',
        name: 'admin.settings',
        component: Settings,
      },
    ],
  },
  {
    path: '/approver',
    // name: 'approver',
    component: ApproverRoot,
    children: [
      {
        path: '/',
        name: 'approver.home',
        component: ApproverHome,
      },
      {
        path: '/approver/pending-approval',
        name: 'approver.pending-approval',
        component: AdminPendingApproval,
      },
      {
        path: '/approver/price-settings',
        name: 'approver.price-settings',
        component: AdminPriceSettings,
      },
      {
        path: '/approver/seller-records',
        name: 'approver.seller-records',
        component: AdminSellerRecords,
      },
      {
        path: '/approver/print',
        name: 'approver.print',
        component: CSPrint,
      },
      {
        path: '/approver/settings',
        name: 'approver.settings',
        component: Settings,
      },
    ],
  },
];

// TODO: implement redirect to login page when not logged in
const router = new VueRouter({
  // mode: 'history',
  routes,
});

export default router;
